import Input from './lib/MaskedInput';
export const MaskedInput = Input;
export default Input;
